import { UserPermissionsResponse, UserResponse } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class CurrentUserService {
  public async getCurrentUser(): Promise<UserResponse> {
    return ExecuteEndpoint('current-user', 'GET');
  }

  public async getUserPermissions(): Promise<UserPermissionsResponse> {
    return ExecuteEndpoint('current-user/permissions', 'GET');
  }
}
